import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import serviceToTQInterface from 'services/tq-adapter/serviceToTQInterface';
import { OneServiceNoParams } from 'types/services/services';

/**
 * Provide the ability to prefetch a service.
 * @returns prefetch service function to prefetch a service.
 */
const usePrefetchQueryServiceNoParams = () => {
  const queryClient = useQueryClient();

  return useCallback(
    <Data,>(service: OneServiceNoParams<Data>) => {
      const options = serviceToTQInterface(queryClient, service);

      return queryClient.prefetchQuery(options);
    },
    [queryClient],
  );
};

export default usePrefetchQueryServiceNoParams;
